import React from 'react';
import { GenericSelect } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';
import { PAYMENT_DURATIONS } from './DropdownContent';

const AccountPaymentMade = () => (
  <Content>
    {({
      accountDetailsPaymentMadeTitle = '',
      accountDetailsFormErrorSelect = '',
      accountDetailsPaymentMadeTitleHelpText = ''
    }) => (
      <Field name="howPaymentMade" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            inputId="howPaymentMade"
            title={accountDetailsPaymentMadeTitle}
            validationMessage={touched && !!error ? accountDetailsFormErrorSelect : ''}
            description={accountDetailsPaymentMadeTitleHelpText}
          >
            <Field name="howPaymentMade" validate={isRequired} component="select">
              {({ input }) => (
                <GenericSelect
                  name="howPaymentMade"
                  {...input}
                  items={PAYMENT_DURATIONS}
                  selectedId={!input.value ? null : input.value}
                  onChange={selectedId => {
                    input.onChange(selectedId);
                  }}
                />
              )}
            </Field>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);
export default AccountPaymentMade;
